import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import Select from "react-select";
import { useFormik } from "formik";
import * as yup from "yup";

import { useAuth } from "../../hooks/useAuth";
import { fetchActionsUtil } from "../../utils/helpers";
import ConfirmDialog from "../ConfirmDialogue";
import ModalLoader from "../utils/ModalLoader";
import AddAccounts from "./AddAccounts";
import CloseIcon from "mdi-react/CloseIcon";

const wareCategory = ["", "Stock", "Assets", "Comsumables"];
const productLine = ["", "Solid", "Liquid", "Gas"];

const EditPlantModal = (props) => {
  const { backendUrl } = useAuth();

  const [openAccountModal, setOpenAccountModal] = useState(false);

  const getThings = async () => {
    const datas = {};
    if (props?.plantId) {
      const acc = await fetchActionsUtil(
        `${backendUrl}/api/accounts/accountLists/CURRENT ASSET`,
        "GET",
      );

      const { Plant } = await fetchActionsUtil(
        `${backendUrl}/api/production/plant/${props.plantId}`,
        "GET",
      );

      datas.accounts = acc?.accountDes?.map((el) => ({
        value: el.AccountID,
        label: el.Description,
      }));

      datas.Plant = Plant[0][0];
    }

    return datas;
  };
  const { data, isFetching, refetch } = useQuery(
    ["FETCH_PLANT", props.plantId],
    () => getThings(),
    {
      keepPreviousData: true,
    },
  );

  useEffect(() => {
    formik.setFieldValue("Plant_Name", data?.Plant?.Plant_Name);
    formik.setFieldValue("Manu_Type", data?.Plant?.Manu_Type);
    formik.setFieldValue("Prod_Line", data?.Plant?.Prod_Line);
    formik.setFieldValue("account", data?.Plant?.Plant_Account?.AccountID);
  }, [data]);

  //   console.log(data);
  const updatePlant = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/production/plant/${props.plantId}`,
        "PUT",
        "",
        payload,
      ),
    {
      onSuccess: () => {
        toast.success("Plant Updated Successfully");
        props.refetch();
        props.onHide();
      },
      onError: ({ message }) => {
        message ? toast.error(message) : toast.error("Unable to edit plant");
      },
    },
  );

  const formik = useFormik({
    initialValues: {
      Plant_Name: "",
      Manu_Type: "",
      Prod_Line: "",
      account: "",
    },
    validationSchema: yup.object().shape({
      account: yup.string().required("Account is required"),
    }),
    onSubmit: async (values) => {
      if (formik.values.Plant_Name === "") {
        return formik.setFieldError("Plant_Name", "Plant Name is required");
      } else if (formik.values.Manu_Type === "") {
        return formik.setFieldError(
          "Manu_Type",
          "Manufacture Type is required",
        );
      } else if (formik.values.Prod_Line === "") {
        return formik.setFieldError("Prod_Line", "Product Line is required");
      }
      if (
        await ConfirmDialog({
          title: "Edit Plant",
          description: `Are you sure you want to edit this plant `,
        })
      ) {
        // console.log(values);
        updatePlant.mutate(values);
      }
    },
  });

  const openAccount = () => {
    if (formik.values.Plant_Name === "") {
      return formik.setFieldError("Plant_Name", "Plant Name is required");
    } else {
      setOpenAccountModal(true);
    }
  };

  const setAccountReturn_WH = (id) => {
    formik.setFieldValue("account", id.toString());
  };

  return (
    <Modal
      onHide={props.onHide}
      show={props.show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div>
          <div>
            <div className="d-flex justify-content-between">
              <h6>Edit {props?.singlePlant}</h6>
              <div role="button" className="text-lg" onClick={props.onHide}>
                <CloseIcon />
              </div>
            </div>
            <p className="text-muted">Edit {props?.singlePlant}</p>
          </div>
          <div className="mt-3">
            {/*  */}
            <div className="mb-3">
              <label className="col-form-label fw-bold">Plant Name</label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  value={
                    formik.values.Plant_Name ? formik.values.Plant_Name : ""
                  }
                  name="Plant_Name"
                  onChange={formik.handleChange}
                />
                <span className="form-control-feedback text-danger">
                  {formik.errors.Plant_Name}
                </span>
              </div>
            </div>
            {/*  */}
            <div className="mb-3">
              <label className="col-form-label fw-bold">Production Line</label>
              <div className="form-group">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={formik.values.Prod_Line}
                  name="Prod_Line"
                  onChange={formik.handleChange}
                >
                  {productLine.map((a, i) => (
                    <option key={i} value={a}>
                      {a}
                    </option>
                  ))}
                </select>
                <span className="form-control-feedback text-danger">
                  {formik.errors.Prod_Line}
                </span>
              </div>
            </div>
            {/*  */}
            <div className="mb-3">
              <label className="col-form-label fw-bold">
                Manufacturing Type
              </label>
              <div className="form-group">
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={formik.values.Manu_Type}
                  name="Manu_Type"
                  onChange={formik.handleChange}
                >
                  {wareCategory.map((a, i) => (
                    <option key={i} value={a}>
                      {a}
                    </option>
                  ))}
                </select>
                <span className="form-control-feedback text-danger">
                  {formik.errors.Manu_Type}
                </span>
              </div>
            </div>
            {/*  */}

            <div className="mb-3 row">
              <label className="col-form-label fw-bold">
                Map to GL account
              </label>
              <div className="form-group col-10">
                <Select
                  closeMenuOnSelect={true}
                  value={data?.accounts?.find(
                    (el) => el.value === formik.values.account,
                  )}
                  onChange={(selected) => {
                    formik.setFieldValue("account", selected.value);
                  }}
                  options={data?.accounts}
                />
                <span className="form-control-feedback text-danger">
                  {formik.errors.account}
                </span>
              </div>
              <div className="col-2">
                <button
                  size="sm"
                  className="btn btn-primary"
                  onClick={openAccount}
                >
                  + Add
                </button>
              </div>
            </div>
            {/*  */}
          </div>
        </div>
      </Modal.Body>
      <div className="d-inline-flex justify-content-end m-4">
        <button className="btn bg print mx-4" onClick={props.onHide}>
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={formik.handleSubmit}
        >
          Edit Plant
        </button>
      </div>
      <ModalLoader show={isFetching || updatePlant.isLoading} />
      <AddAccounts
        onHide={() => setOpenAccountModal(false)}
        show={openAccountModal}
        warehouse={formik.values.W_name}
        setAccountReturn_WH={setAccountReturn_WH}
        refetch={refetch}
      />
    </Modal>
  );
};

export default EditPlantModal;
